import Box, { BoxProps } from '@mui/material/Box'
import vehicleImg from '../assets/images/vehicle.png'
import { Vehicle } from '../../../shared/types/vehicle.types'
import {
    getVehiclePictureImageStyles,
    vehiclePictureStyles,
} from './VehiclePicture.styles'

interface VehiclePictureProps {
    vehicle: Vehicle
    imgSx?: BoxProps['sx']
}

const VehiclePicture: React.FC<VehiclePictureProps> = ({ vehicle, imgSx }) => {
    return (
        <Box sx={vehiclePictureStyles.root}>
            <Box
                component="img"
                src={vehicle.pictureUrl ?? vehicleImg}
                alt={vehicle.model}
                sx={getVehiclePictureImageStyles(imgSx)}
            />
        </Box>
    )
}

export default VehiclePicture
